// src/hooks/useMyTask.js.js
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { setMyTasks, setError, clearMyTasks } from '../features/myTaskSlice';

const API_URL = 'https://api-4h4srbodqa-uc.a.run.app/api';
// const API_URL = 'http://localhost:4000/api';

export const useMyTask = (userId, role) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['myTask', userId, role],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/user/${userId}/role-projects-task?role=${role}`);
      // const { data } = await axios.get(`http://127.0.0.1:4000/api/user/${userId}/role-projects-task?role=${role}`);
      console.log('Raw API response:', data); // Log the raw API response
      return data;
    },
    onSuccess: (data) => {
      console.log('Setting mt Tasks in Redux:', data);
      dispatch(setMyTasks(data));
    },
    onError: (error) => {
      console.error('Fetch error:', error);
      dispatch(setError(error.message));
    },
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};